import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { TeamsOnlyGate } from '@/app/gates/index.js';

export const Route = createFileRoute('/blocked')({
  component: BlockedPage,
});

/**
 * /blocked — shown when user opens the app outside Microsoft Teams.
 * TeamsOnlyGate renders the branded "open in Teams" screen as a child-less gate.
 */
function BlockedPage(): JSX.Element {
  return (
    <TeamsOnlyGate>
      <></>
    </TeamsOnlyGate>
  );
}
